import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.authenticationService.currentUserValue;
    const language = localStorage.getItem('language') || 'en';
    const SignalRConnectionId = this.authenticationService.currentSignalRConnectionId;

    const requestHeader = {
      'accept-language': language,
      'ClientType': 'RestaurantSystem',
      lang: language
    } as any;

    if (SignalRConnectionId) {
      requestHeader.SignalRConnectionId = SignalRConnectionId;
    }
    if (localStorage.getItem('deviceId')) {
      requestHeader.deviceId = localStorage.getItem('deviceId');
      requestHeader.deviceType = localStorage.getItem('deviceType');
    }

    if (currentUser && currentUser.token) {
      requestHeader.Authorization = `Bearer ${currentUser.token}`
    }
    request = request.clone({ setHeaders: requestHeader });
    this.dateReplacer(request.body);
    return next.handle(request);
  }

  dateReplacer(obj: any) {
    if (obj) {
      for (const k in obj) {
        if (obj.hasOwnProperty(k)) {
          if (obj[k] instanceof Object) {
            obj[k] = this.dateReplacer(obj[k]);
          }
          if (obj[k] instanceof Date) {
            // obj[k] = new Date(`${obj[k]} UTC`);
            obj[k] = this.toLocalISOString(obj[k]);
          }
        }
      }
      return obj;
    }
  }
  toLocalISOString(date: Date): string {
    const pad = (num: number) => num.toString().padStart(2, '0');
    return (
      date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds())
    );
  }
}
